<template>
  <div
    class="page-cover"
    :style="cover && cover.image ? { backgroundImage: 'url(' + cover.image + ')' } : {}"
  >
    <div class="page-cover__content">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="page-cover__title" v-if="resolvedTitle">
              {{ resolvedTitle }}
            </div>
            <div
              class="page-cover__text editor"
              v-if="cover && cover.description"
              v-html="cover.description"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "page-cover",
  props: {
    cover: {
      type: Object,
    },
  },
  computed: {
    lang() {
      return this.$store.state.lang;
    },
    resolvedTitle() {
      // 1. Cari path-a uyğun header-menu sətirini tap, onun dil-uyğun adını qaytar
      const menus = this.$store.getters["headerMenus/allMenus"] || [];
      const path = this.$route.path;
      const key = "description_" + this.lang;

      // Eyni path üçün bir neçə menyu sətri ola bilər (məs. /register/nurse) —
      // cari dildə adı dolu olanı üstün tut, yoxsa ilk uyğun sətir.
      const exact = menus.filter((m) => m.path && m.path === path);
      let menu = exact.find((m) => m[key] && String(m[key]).trim()) || exact[0];

      // Sonra prefix match (məs. "/career/work" path "/career"-dən başlasa)
      if (!menu) {
        const prefix = menus.filter(
          (m) => m.path && m.path !== "/" && path.indexOf(m.path) === 0,
        );
        menu = prefix.find((m) => m[key] && String(m[key]).trim()) || prefix[0];
      }

      if (menu) {
        const val = menu[key];
        if (val && typeof val === "string" && val.trim()) {
          return val;
        }
      }

      // 2. Fallback: cover.title (PageCover store-undan gələn AboutType.name)
      if (this.cover && this.cover.title) {
        return this.cover.title;
      }

      return "";
    },
  },
};
</script>
